<p-dialog
  [(visible)]="visible"
  [modal]="true"
  [dismissableMask]="true"
  [draggable]="false"
  [resizable]="false"
  [closeOnEscape]="true"
  [style]="{width: '90vw', height: '90vh', maxWidth: '1400px'}"
  [contentStyle]="{padding: '0', overflow: 'hidden', display: 'flex', flexDirection: 'column'}"
  (onShow)="onShow()"
  (onHide)="onHide()"
  styleClass="p-dialog-scheda-nuova"
>
<ng-template pTemplate="header">
  <div class="dialog-header" style="padding: 0.5rem; display: flex; align-items: center; justify-content: space-between;">
    <div style="display: flex; align-items: center;">
      <span class="material-icons header-icon">location_on</span>
      <h2>{{ titolo }}</h2>
      <div *ngIf="scheda?.vecchioCodiceUmvs" class="code-badge legacy-code" style="background-color: #f0f0f0; padding: 0.25rem 0.5rem; border-radius: 4px; margin-left: 1rem; border-left: 3px solid #8f5cb7;">
        <span class="code-value" style="font-weight: bold; color: #8B4513;" pTooltip="VECCHIO CODICE UMVS" tooltipPosition="top">{{ scheda?.vecchioCodiceUmvs }}</span>
      </div>
      <div class="code-badge" style="background-color: #f0f0f0; padding: 0.25rem 0.5rem; border-radius: 4px; margin-left: 1rem; border-left: 3px solid #4285F4;">
        <span class="code-value" style="font-weight: bold; color: #3a6e75;" pTooltip="NUOVO CODICE" tooltipPosition="top">{{ scheda?.codice }}</span>
      </div>
      <button
        pButton
        type="button"
        icon="pi pi-times"
        class="p-button-rounded p-button-text p-button-danger close-button"
        (click)="onHide()"
        pTooltip="Chiudi"
        tooltipPosition="left">
      </button>
    </div>
  </div>
</ng-template>
  <div class="mappa-container">
    <div class="map-actions">
     <!--  <button
        pButton
        pTooltip="Zoom sulla geometria selezionata"
        tooltipPosition="bottom"
        icon="pi pi-search"
        [disabled]="!datiGeoJSON"
        (click)="zoomSuScheda()"
        class="p-button-rounded p-button-text">
      </button> -->

      <button
        pButton
        pTooltip="{{opzioniMappa.mostraComuni ? 'Nascondi confini comuni' : 'Mostra confini comuni'}}"
        tooltipPosition="bottom"
        [icon]="opzioniMappa.mostraComuni ? 'pi pi-eye-slash' : 'pi pi-eye'"
        (click)="toggleConfiniComuni()"
        class="p-button-rounded p-button-text">
      </button>
    </div>
    <div #map class="mappa"></div>
  </div>
</p-dialog>
